import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  preDefinedMetrics: any;
  userDefinedMetrics: any;
  combinedMetricsMeta: any;
  combinedMetricsKey: any;
};

type Action = {
  setPredefinedMetricsMeta: (metricsMeta: State['preDefinedMetrics']) => void;
  setUserDefinedMetricsMeta: (metricsMeta: State['userDefinedMetrics']) => void;
  setCombinedMetricsMeta: any;
  setCombinedMetricsKey: any;
};

const initialState: State = {
  preDefinedMetrics: {},
  userDefinedMetrics: {},
  combinedMetricsMeta: {},
  combinedMetricsKey: [],
};

const metricsStore = create(
  devtools(
    (set: any, get: any) => ({
      ...initialState,
      setPreDefinedMetricsMeta: (metricsMeta) => set(() => ({ preDefinedMetrics: metricsMeta })),
      setUserDefinedMetricsMeta: (metricsMeta) => set(() => ({ userDefinedMetrics: metricsMeta })),
      setCombinedMetricsMeta: (combinedMetricsMeta) => set(() => ({ combinedMetricsMeta })),
      setCombinedMetricsKey: (combinedMetricsKey) => set(() => ({ combinedMetricsKey })),
    }),
    { name: 'metricStore' },
  ),
);

export default metricsStore;
